module.exports = __webpack_public_path__ + "img/custom_plan_256.ddd80f20.png";